import React from 'react'
import PropTypes from 'prop-types'
import LogService from './services/log-service'
import {RATES_QUERY} from './graphql/queries/rates'
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import withCacheClient from '@cred/shared/hoc/withCacheClient'
import {useQuery} from '@apollo/client'

function getRateRawValue (data) {
  if (data && data.searchRates && data.searchRates[0]) {
    return data.searchRates[0].value
  }
}

function getRateValue (data, options) {
  const rawValue = parseFloat(getRateRawValue(data)),
    optionsParsed = Object.assign({decimals: 2, append: '%', prepend: ''}, options)

  if (rawValue && !isNaN(rawValue)) {
    const convertedRawValue = rawValue.toFixed(optionsParsed.decimals)

    return optionsParsed.prepend + convertedRawValue + optionsParsed.append
  } else {
    return null
  }
}

// Public function for fetching a rate value using GraphQL query result
// Parsing requires a query result object produced by the useQuery hook from apollo
export function parseRateQueryResult({loading, error, data}, rateOptions = undefined) {
  if (error) {
    LogService.error(`[Rates] Error getting a rate: ${error}`)
    return null
  } else if (loading) {
    return null 
  }

  const rate = getRateValue(data, rateOptions)
  return rate
}

const RateGQL = ({
  className,
  decimals,
  append,
  prepend,
  rateType,
  vertical,
  lenderSlug,
  term,
  variable,
  name,
  label
}) => {
  const args = {rateType, vertical, lenderSlug, term, variable, name}

  const queryResult = useQuery(RATES_QUERY, {
    variables: {args, published: true},
    onError: err => console.log(err)
  })

  const rate = parseRateQueryResult(queryResult, {decimals, append, prepend})

  return rate ?
    <>
      <span className={className}>{rate}</span>
      {label}
    </>
    : null
}

RateGQL.propTypes = {
  rateType: PropTypes.string.isRequired,
  vertical: PropTypes.string,
  lenderSlug: PropTypes.string,
  term: PropTypes.number,
  variable: PropTypes.bool,
  name: PropTypes.string,
  decimals: PropTypes.number,
  append: PropTypes.string,
  prepend: PropTypes.string,
  label: PropTypes.element
}

RateGQL.defaultProps = {
  decimals: 2,
  append: '%',
  prepend: ''
}

export {RateGQL}

export default /*#__PURE__*/ withCacheClient(RateGQL)
